<template>
  <a-popover :title="false">
    <template slot="content">
      <div class="p-all">
        <img
          v-if="hotkeyIcon"
          :src="require('@/assets/images/' + hotkeyIcon)"
          class="m-r"
        />
        {{ title }}
      </div>
    </template>
    <div
      class="tool-group-btn"
      v-bind:class="{
        'tool-group-btn__active': active,
        'tool-group-btn__without_select': disableSelect,
      }"
    >
      <div class="tool-group-btn__inner">
        <div
          class="tool-group-btn__item tool-group-btn__icon"
          @click="setToolActive()"
        >
          <i class="fa-light" :class="icon" aria-hidden="true"></i>
        </div>
        <slot v-if="!disableSelect"></slot>
      </div>
    </div>
  </a-popover>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    activeTool: {
      type: Object,
      required: false,
      default: null,
    },
    callback: {
      type: Function,
      required: false,
      default: () => {},
    },
    deselect: {
      required: false,
      type: Boolean,
      default: true,
    },
    disableSelect: {
      required: false,
      type: Boolean,
      default: false,
    },
    hotkeyIcon: {
      required: false,
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["activeTools"]),
    isToolActive() {
      return this.activeTool
        ? this.activeTools.indexOf(this.activeTool.id) !== -1
        : null;
    },
  },
  mounted() {
    this.$accessModule(this.icon, this);
  },
  methods: {
    setToolActive() {
      if (!this.deselect && this.isToolActive) {
        return;
      }
      this.callback();
      if (this.activeTool) {
        if (this.activeTool.id === "Reset") {
          this.$root.$emit("resetAllTools");
          return;
        }
        this.$store.dispatch(
          "updateActiveTools",
          this.isToolActive
            ? this.activeTools.filter((tool) => {
                return tool !== this.activeTool.id;
              })
            : this.activeTools
                .filter((tool) => {
                  return tool === "StackScrollMouseWheel";
                })
                .concat([this.activeTool.id])
        );
      }
    },
  },
};
</script>
